(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pestanas-producto-json"] && !window.DesignMode) return;
  try {
    
  class ProductTabsSection {
    constructor(container) {
      this.container = container;
      this.tabs = this.container.querySelectorAll('.tab-producto-button');
      this.panes = this.container.querySelectorAll('.tab-producto-pane');
      this.init();
    }
    init() {
      if (!this.tabs.length) return;
      this.tabs.forEach(tab => {
        tab.addEventListener('click', (event) => {
          this.activateTab(event.currentTarget);
        });
      });
    }
    activateTab(tab) {
      this.tabs.forEach(item => {
        item.classList.remove('active');
        item.setAttribute('aria-selected', 'false');
      });
      this.panes.forEach(pane => {
        pane.classList.remove('active');
      });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      const targetPaneId = tab.getAttribute('aria-controls');
      this.container.querySelector(`#${targetPaneId}`).classList.add('active');
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.tabs-producto-container').forEach(container => {
      new ProductTabsSection(container);
    });
  });

  /* =================================================================== */
  /* FUNCIONALIDAD PARA DESPLEGAR TABLAS DE PRECIOS EN MARCAJE     */
  /* =================================================================== */
  document.querySelectorAll('.tecnica-toggle-button').forEach(button => {
    button.addEventListener('click', () => {
      const tableDiv = button.nextElementSibling;
      const icon = button.querySelector('.toggle-icon');

      if (tableDiv.style.display === 'none' || tableDiv.style.display === '') {
        tableDiv.style.display = 'block';
        icon.textContent = '−'; // Cambia el ícono a "menos"
      } else {
        tableDiv.style.display = 'none';
        icon.textContent = '+'; // Cambia el ícono a "más"
      }
    });
  });
  

  } catch(e) { console.error(e); }
})();
})();
